import * as Types from '../constants/Types';

export const getRedirectLinks = (filters) => ({ type: Types.REDIRECT_LINK_LIST_ACTION, filters });
export const setRedirectLinks = (redirectLinks) => ({ type: Types.REDIRECT_LINK_LIST_SUCCESS, redirectLinks});

export const getRedirectLinkDetail = (id) => ({ type: Types.REDIRECT_LINK_DETAIL_ACTION, id })
export const setRedirectLinkDetail = (redirectLink) => ({ type: Types.REDIRECT_LINK_DETAIL_SUCCESS, redirectLink });

export const updateRedirectLinkDetail = (redirectLink) => ({ type: Types.REDIRECT_LINK_DETAIL_UPDATE_ACTION, redirectLink });
export const createRedirectLinkDetail = (redirectLink) => ({ type: Types.REDIRECT_LINK_DETAIL_CREATE_ACTION, redirectLink });
export const deleteRedirectLinkDetail = (redirectLink, filters) => ({ type: Types.REDIRECT_LINK_DETAIL_DELETE_ACTION, redirectLink, filters });